export enum Breakpoint {
  SM = 320,
  M = 768,
  MD = 1152,
  L = 1440,
  XL = 1920,
}
